import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
import { BillingGroupModelType } from '@teinor/erp/types/company/config/billingGroup'
import { BillingTypeBuyModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy'
import { BillingTypeBuyOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy/billingTypeBuyOption'
import { BillingTypeSellModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell'
import { BillingTypeSellOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell/billingTypeSellOption'

export interface BillingGroupAction {
    type: 'CHANGE_BILLINGGROUP'
    payload: BillingGroupModelType[]
}

interface BillingTypeBuyExt extends BillingTypeBuyModelType {
    billingTypeBuyOptionsDict: { [id: number]: BillingTypeBuyOptionModelType }
}
interface BillingTypeSellExt extends BillingTypeSellModelType {
    billingTypeSellOptionsDict: { [id: number]: BillingTypeSellOptionModelType }
}
interface BillingGroupModelTypeExt extends BillingGroupModelType {
    billingTypesBuyDict: { [id: number]: BillingTypeBuyExt }
    billingTypesSellDict: { [id: number]: BillingTypeSellExt }
}
export type DictionaryBillingGroup = {
    defaultBillingGroupId?: number
    billingTypesAllBuyOptions: { [id: number]: BillingTypeBuyOptionModelType }
    billingTypesAllSellOptions: { [id: number]: BillingTypeSellOptionModelType }
    dictionaryBillingGroup: DictionaryBillingGroupTy
}
export type DictionaryBillingGroupTy = { [id: number]: BillingGroupModelTypeExt }

export type BillingGroupPayload = null | DictionaryBillingGroup

export default function billingGroups(state: BillingGroupPayload = null, action: BillingGroupAction): DictionaryBillingGroup | null {
    switch (action.type) {
        case 'CHANGE_BILLINGGROUP':
            const dictionaryBillingGroup = dictionaryComplexFromJsonArr(action.payload || [])
            let billingTypesAllBuyOptions = {}
            let billingTypesAllSellOptions = {}
            let defaultBillingGroupId: number | undefined
            for (const key in dictionaryBillingGroup) {
                const billingGroup = dictionaryBillingGroup[key]
                if (billingGroup.is_default) {
                    defaultBillingGroupId = billingGroup.id
                }
                if (billingGroup.billingTypesBuy && billingGroup.billingTypesBuy.length) {
                    billingGroup.billingTypesBuyDict = dictionaryComplexFromJsonArr(billingGroup.billingTypesBuy)
                    for (const idBillingType in billingGroup.billingTypesBuyDict) {
                        const billingType = billingGroup.billingTypesBuyDict[idBillingType]
                        if (billingType.BillingTypeBuyOptions) {
                            billingType.billingTypeBuyOptionsDict = dictionaryComplexFromJsonArr(billingType.BillingTypeBuyOptions)
                            billingTypesAllBuyOptions = { ...billingTypesAllBuyOptions, ...billingType.billingTypeBuyOptionsDict }
                        }
                    }
                }
                if (billingGroup.billingTypesSell && billingGroup.billingTypesSell.length) {
                    billingGroup.billingTypesSellDict = dictionaryComplexFromJsonArr(billingGroup.billingTypesSell)
                    for (const idBillingType in billingGroup.billingTypesSellDict) {
                        const billingType = billingGroup.billingTypesSellDict[idBillingType]
                        if (billingType.BillingTypeSellOptions) {
                            billingType.billingTypeSellOptionsDict = dictionaryComplexFromJsonArr(billingType.BillingTypeSellOptions)
                            billingTypesAllSellOptions = { ...billingTypesAllSellOptions, ...billingType.billingTypeSellOptionsDict }
                        }
                    }
                }
            }
            return state = { defaultBillingGroupId, dictionaryBillingGroup, billingTypesAllBuyOptions, billingTypesAllSellOptions }
        default:
            return state
    }
}